module.exports = __webpack_public_path__ + "static/img/new-google-pay.95f3d7cc.svg";